import React from "react";
import { l10n } from "../../common/constants";
import { useSelector } from "react-redux";
import { getDate, getTime } from "../../common/helpers";
import { Accordion, Card, Spinner } from "react-bootstrap";
import {
  getAnswerDetails,
  getFormDefinition,
  getPluginKey,
  getSeragamGender,
  getSeragamSize,
  PLUGIN_MISSION_TRIP,
  PLUGIN_SERAGAM,
} from "../form-builder/schemaRuntime";

const seragamExclusives = Array.from(
    { length: 20 },
    (_, index) => `seragam${index + 1}`
);
const missionTripExclusives = ["missiontripgsc", "missiontrip"];
const eventWithoutLocationExclusives = [
  "eventwithoutlocation",
  "eventwithoutlocation2",
  "eventwithoutlocation3",
];
const missionTripAccommodationLabels = {
  13: "Iya, saya tiba tanggal 13 Juni",
  14: "Iya, saya tiba tanggal 14 Juni",
  15: "Iya, saya tiba tanggal 15 Juni",
  tidak: "Tidak",
};
const missionTripHotelLabels = {
  goldentulip: "Golden Tulip",
  oakwood: "Oakwood",
  sahid: "Sahid",
};
const missionTripRoomTypeLabels = {
  studio: "Studio/deluxe room",
  1: "1BR",
  2: "2BR",
  3: "3BR",
};
const seragamGroupLabels = {
    Pria: "seragamGroupMan",
    Wanita: "seragamGroupWoman",
    Anak: "seragamGroupKids",
    "Pilihan Ukuran": "seragamGroupDefault",
};

export default function MyTickets(props) {
    const { language } = useSelector((state) => ({
        language: state.userReducer.language,
    }));
    const excludedExclusives = [
      "christmas2025",
      "christmascelebration1",
      "christmascelebration2",
      "christmascelebration3",
      "christmascelebration4",
      "christmascelebration5",
    ];

  function capitalizeFirstLetter(string) {
    if(string){
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else return null;
  }

  function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

  function getAogHubDetails(exclusive, extras) {
    if (!extras) {
      return [];
    }

    if (extras.pilihan) {
      const details = [];

      if (exclusive === "aoghub") {
        details.push({ label: "Pilihan", value: extras.pilihan });
      }

      if (extras.pilihan === "Facilitator Group Discussion") {
        details.push({
          label: "Sedang berada di kota / negara mana?",
          value: extras.lokasiSekarang,
        });
      } else {
        details.push({ label: "Kota Asal", value: extras.kotaAsal });
        details.push({
          label:
            exclusive === "aoghubonline"
              ? "Kota / Negara Tujuan"
              : extras.pilihan === "Berencana Kuliah di Luar Negeri"
                ? "Negara Tujuan"
                : "Kota Tujuan",
          value: extras.tujuan,
        });
      }

      return details;
    }

    const details = [
      {
        label: "Sedang Kuliah di Luar Negeri",
        value: !!extras.isCurrentlyAbroad ? "Ya" : "Tidak",
      },
    ];

    if (extras.isCurrentlyAbroad) {
      details.push({ label: "Sedang dimana?", value: extras.origin });
    } else {
      details.push({ label: "Kota Asal", value: extras.origin });
      details.push({
        label:
          exclusive === "aoghubonline"
            ? "Kota / Negara Tujuan"
            : "Kota Tujuan",
        value: extras.destination,
      });
    }

    return details;
  }

  function getMissionTripDetails(exclusive, extras) {
    if (!extras) {
      return [];
    }

    if (exclusive === "missiontrip" && extras.jenisPaket) {
      const isMissionTripAccommodationPackage =
        extras.jenisPaket === "Paket Akomodasi" ||
        extras.jenisPaket === "Paket Lengkap";
      const jenisPaket =
        extras.jenisPaket === "Paket Lengkap"
          ? "Paket Akomodasi"
          : extras.jenisPaket;
      const details = [
        { label: "Jenis Paket", value: jenisPaket },
        { label: "Nama Paket", value: extras.namaPaket },
        {
          label: "Pelayanan Alternatif",
          value: extras.pelayananAlternatif,
        },
      ];

      if (isMissionTripAccommodationPackage) {
        details.push({
          label: "Punya Teman Sekamar",
          value: extras.punyaTemanSekamar ? "Ya" : "Tidak",
        });

        if (extras.punyaTemanSekamar) {
          details.push({
            label: "Nama Teman Sekamar",
            value: extras.namaTemanSekamar,
          });
          details.push({
            label: "NIJ Teman Sekamar",
            value: extras.nijTemanSekamar,
          });
          details.push({
            label: "Hubungan Teman Sekamar",
            value: extras.hubunganTemanSekamar,
          });
        } else {
          details.push({
            label: "Bersedia Diaturkan Teman Sekamar",
            value: extras.bersediaDiaturkanTemanSekamar ? "Ya" : "Tidak",
          });
        }
      }

      return details;
    }

    if (extras.akomodasi) {
      const details = [
        {
          label: "Akomodasi",
          value: missionTripAccommodationLabels[extras.akomodasi] || "",
        },
      ];

      if (extras.akomodasi !== "tidak") {
        details.push({
          label: "Hotel",
          value: missionTripHotelLabels[extras.hotel] || "",
        });
        details.push({
          label: "Tipe Kamar",
          value: missionTripRoomTypeLabels[extras.tipekamar] || "",
        });
      }

      return details;
    }

    return [];
  }

  // Redirect user to ticket page
  const handleTicketClick = eventCode => {
    window.location.href = `https://accounts.gms.church/:register_success?event_code=${eventCode}`;
  }

  const translateSeragamSessionName = (name = "") =>
    name.replace(/\[(.*?)\]/g, (_, rawGroupName) => {
      const groupName = rawGroupName.trim();
      const translationKey = seragamGroupLabels[groupName];

      if (!translationKey) {
        return `[${groupName}]`;
      }

      return `[${l10n[translationKey][language]}]`;
    });

  return (
    <Accordion className='fixed-bottom' style={accordionStyle}>
      <Card style={cardStyle}>
    
        {props.tickets.sort((a, b) => { return a.sub_event.start_date > b.sub_event.start_date }).map((ticket, i) => 
          {
            let extras = null;
            if(isJsonString(ticket.extras)){
              extras = JSON.parse(ticket.extras)
            } else if(ticket.extras){
              extras = ticket.extras
            }
            const mainEvent = ticket.sub_event.main_event;
            const {exclusive} = mainEvent;
            const formDefinition = getFormDefinition(mainEvent);
            const pluginKey = getPluginKey(mainEvent);
            const isSeragamTicket =
              seragamExclusives.includes(exclusive) ||
              pluginKey === PLUGIN_SERAGAM;
            const isMissionTripTicket =
              missionTripExclusives.includes(exclusive) ||
              pluginKey === PLUGIN_MISSION_TRIP;
            const seragamSessionTitle = pluginKey === PLUGIN_SERAGAM
              ? `${getSeragamSize(ticket.sub_event)} [${getSeragamGender(ticket.sub_event)}]`
              : translateSeragamSessionName(ticket.sub_event.name);
            const aogHubDetails =
              exclusive === "aoghub" || exclusive === "aoghubonline"
                ? getAogHubDetails(exclusive, extras)
                : [];
            const missionTripDetails = isMissionTripTicket
              ? getMissionTripDetails(pluginKey === PLUGIN_MISSION_TRIP ? "missiontrip" : exclusive, extras)
              : [];
            const dynamicDetails = formDefinition && pluginKey !== PLUGIN_MISSION_TRIP && extras
              ? getAnswerDetails(formDefinition, ticket.sub_event, extras, language, "ticket")
              : [];
          return (
          <div key={`ticket-${i}`}>
          {/* Header - 'Tiket Saya / My Ticket' */}
          {i===0 ? (
          <Accordion.Toggle as={Card.Header} eventKey={`${i}`} style={ticketHeaderStyle}>
            <p style={ticketHeaderTextStyle}>{l10n['myTicket'][language]}</p>
          </Accordion.Toggle>
          ) : null }
          {/* Body - Ticket List*/}
          <Accordion.Collapse eventKey={`${i}`}>
            <div className="card-block">
              <div className="card-body d-flex justify-content-between align-items-center" style={cardBodyStyle}>
                <div style={cardInnerStyle}>
                  {/* Badge - Notify user ticket for today */}
                  {getDate(new Date()) === getDate(ticket.sub_event.start_date) ? <Spinner animation='grow' variant='danger' size='sm' style={badgeStyle} /> : null}
                  <div onClick={() => handleTicketClick(ticket.sub_event.main_event.code)} className="row">
                    {((exclusive === "postmaritalclass" || exclusive === "postmaritalclassspecial") && 
                      ticket.paid_status === "PAID") && (
                      <div className="col-12" style={{ paddingLeft: "15px", marginBottom: "10px" }}>
                        <div style={{ padding: "3px 8px", borderRadius: "4px", backgroundColor: "#FFE58D", display: "flex", alignItems: "center", height: "24px", color: "#625f61", fontSize: "11px" }}>
                          <span>
                            Terimakasih, kami akan menghubungi anda kembali.
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="col-9">
                    <p className="card-text" style={{ marginBottom: '0px', fontSize: '14px', color: '#231f20', fontWeight: 'bold' }}>
                    {extras && ( exclusive === "christmascelebration" || exclusive === "stb" ) && parseInt(extras.forvip) === 1 ? ticket.sub_event.main_event.referencename : ticket.sub_event.main_event.name}
                    </p>
                    {!isSeragamTicket && !isMissionTripTicket && (
                      <p className="card-text" style={{ marginBottom: '0px' }}>
                        <small style={{ color: '#231f20' }}>
                          {getDate(ticket.sub_event.start_date)} - {getTime(ticket.sub_event.start_date)}
                        </small>
                      </p>
                    )}
                    
                    <h6 className="card-title" style={{ marginBottom: '0px', color: '#231f20', fontSize: '2rem' }}><b>{isSeragamTicket ? seragamSessionTitle : ticket.sub_event.name}</b> </h6>

                    
                      {!eventWithoutLocationExclusives.includes(exclusive) &&
                        !isMissionTripTicket && (
                          <p className="card-text" style={{ marginBottom: '0px', fontSize: '14px', color: '#231f20' }}>
                              { excludedExclusives.includes(exclusive)
                                ? ticket.sub_event.room.name
                                : (
                                    <>
                                      {ticket.sub_event.main_event.church.name} &#x2022; {ticket.sub_event.room.name}
                                    </>
                                  )
                              }
                          </p>
                        )}
                    

                    {extras && exclusive === "aogrun" ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                      Notes:<br />- Type <strong>{capitalizeFirstLetter(extras.type)}</strong><br />- Jersey <strong>{extras.size}</strong><br />- Pickup on <strong>{extras.pickup}</strong>
                      <br />Schedule: SCC: 11-12 Feb, PCM 12 Feb, MCC 12 Feb, SCCWD 14-16 Feb
                      </div> 
                    ) : null}
                    {extras && (exclusive === "postmaritalclass" || exclusive === "postmaritalclassspecial") ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61', maxHeight: '100px', overflowY: 'auto', width: '100%' }}>
                        Notes:
                        {[
                          { label: "NIJ", value: props.nij },
                          { label: "Nama", value: props.name },
                          { label: "WA", value: props.phone },
                        ].map((field, key) => (
                          <div key={key} style={{ marginTop: '4px' }}>
                            - {field.label}:<br />
                            <strong style={{ marginLeft: '10px' }}>{field.value}</strong>
                          </div>
                        ))}
                        {props.customForm && props.customForm.map((field, key) => (
                          <div key={key} style={{ marginTop: '4px' }}>
                            - {field.label}:<br />
                            <strong style={{ marginLeft: '10px' }}>{extras[field.key] ? (Array.isArray(extras[field.key]) ? extras[field.key].join(', ') : extras[field.key]) : "-"} {field.suffix && extras[field.key] ? field.suffix : ""}</strong>
                          </div>
                        ))}
                      </div>
                    ) : null}
                    {extras && exclusive === "gmsrunmanado" ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                      Notes:<br />- Jersey <strong>{extras.size}</strong><br />
                      Pickup on <br /><strong>Racekit di GMS Manado, Jl. Wolter Monginsidi No.1, Kompleks Bahumall,<br />
                      Samping Apartemen Lagoon/Hotel Best Western<br />
                      Penukaran Racekit tanggal 1-3 November 2023<br />
                      Jam penukaran mulai 10.00 sampai 20.00 WITA
                      </strong>
                      </div> 
                    ) : null}
                    {extras && exclusive === "gmsrunbalikpapan" ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                      Notes:<br />
                      - Type <strong>{capitalizeFirstLetter(extras.type)}</strong><br />
                      - Jersey <strong>{extras.size}</strong><br />
                      Racepack Pickup <br />
                      <strong>
                        Racekit di GMS Balikpapan, Jl. Mayjend Sutoyo Rt.44 No.32<br />
                        Penukaran Racekit tanggal 04 Agustus 2024<br />
                        Jam penukaran mulai 10.00 sampai 17.00 WITA
                      </strong>
                      </div> 
                    ) : null}
                    {extras && exclusive === "aogfindingmajor" ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                      Notes:<br />- Kelas: <strong>{extras.kelas}</strong><br />
                      </div> 
                    ) : null}
                    {missionTripDetails.length > 0 ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                      Notes:<br />
                      {missionTripDetails.map((detail, index) => (
                        <React.Fragment key={`missiontrip-detail-${index}`}>
                          - {detail.label}: <strong>{detail.value || "-"}</strong><br />
                        </React.Fragment>
                      ))}
                      </div> 
                    ) : null}
                    {dynamicDetails.length > 0 ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                        Notes:<br />
                        {dynamicDetails.map((detail) => (
                          <React.Fragment key={`dynamic-detail-${detail.key}`}>
                            - {detail.label}: <strong>{String(detail.value || "-")}</strong><br />
                          </React.Fragment>
                        ))}
                      </div>
                    ) : null}
					          {extras && exclusive === "checklistinterpreter" ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                      Notes:<br />- Interpreter: <strong>{(extras.interpreter === 0 ? 'Tidak' : 'Ya')}</strong><br />
                      </div> 
                    ) : null}
                    {extras && (exclusive === "aogbootcamp1" || exclusive === "aogbootcamp1regional" || exclusive === "aogbootcamp2" || exclusive === "aogbootcamp2regional") ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                        Notes:<br />
                        {extras.jenisPendaftaran === "wali" ? <> - Nama: {extras.name} <br/></> : ""}
                        {extras.jenisPendaftaran === "wali" ? <> - Sudah bergabung cg: {extras.isCG ? "Sudah" : "Belum"} <br/></> : ""}
                        {extras.jenisPendaftaran === "wali" ? <> - Usia: {extras.age} <br/></> : ""}
                        {extras.jenisPendaftaran === "wali" ? <> - Jenis Kelamin: {extras.gender} <br/></> : ""}
                        - Nomor telepon: {extras.phoneNumber}<br />
                        - Alergi dan Riwayat penyakit: {extras.medicalCondition}<br />
                      </div> 
                    ) : null}

                    {extras && (exclusive === "christmascelebration" || exclusive === "stb") && parseInt(extras.forvip) === 1 ? (
                      <div style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                        Catatan: {extras.catatan}
                      </div> 
                    ) : null}

                    {aogHubDetails.length > 0 ? (
                      <div className="d-flex flex-column" style={{ marginBottom: '0px', fontSize: '12px', color: '#625f61' }}>
                        <div> Detail: </div>
                        {aogHubDetails.map((detail, index) => (
                          <div key={`aoghub-detail-${index}`}>
                            - {detail.label}: <strong>{detail.value || "-"}</strong>
                          </div>
                        ))}
                      </div> 
                    ) : null}
                    </div>
                    <div className="col-3">
                      <div style={{ marginBottom: '0px', fontSize: '3rem', color: '#231f20', textAlign: 'right', whiteSpace: 'nowrap' }}>{ticket.quantity}</div>
                      <div style={{ marginBottom: '0px', fontSize: '10px', color: '#231f20', textAlign: 'right'  }}>{exclusive === "missiontripgsc" ? l10n['kamar'][language] : isMissionTripTicket ? "paket" : l10n['ticket'][language]}</div>
                    </div>
                    </div>
                    <div><hr /></div>
                    <div style={actionRowStyle}>
                      {ticket.paid_status ? (
                        <>
                          {ticket.paid_status==='WAITING' ? (
                            <>
                              {ticket.prevent_cancel !== true && (
                                <div style={actionCancelWrapStyle}>
                                  <button onClick={props.deleteTicket.bind(this, ticket)} style={btnDeleteStyle}>{l10n['cancelTicket'][language]}</button>
                                </div>
                              )}
                              <div style={actionProcessWrapStyle}>
                                <button onClick={props.processPaymentTicket.bind(this, ticket)} style={btnProcessStyle}>
                                  {l10n["continuePayment"][language]}
                                </button>
                              </div>
                            </>
                          ) : ticket.paid_status==='PAID' ? (
                            <div style={infoPaymentStyle}>LUNAS</div>
                          ) : null }
                        </>
                      ) : ticket.prevent_cancel !== true ? (
                        <div style={actionSingleWrapStyle}>
                          <button onClick={props.deleteTicket.bind(this, ticket)} style={btnDeleteStyle}>{l10n['cancelTicket'][language]}</button>
                        </div>
                      ) : null}
                  </div>
                </div>
              </div>
            </div>
          </Accordion.Collapse>
          </div>
          )
          }
        )}
      </Card>
      {(props.tickets.length)>1 ? (
        <>
          {props.tickets.sort((a, b) => { return a.sub_event.start_date > b.sub_event.start_date }).map((ticket, i) => (
          <Accordion.Toggle as={Card.Header} key={`ticketbottom-${i}`} eventKey={`${i}`} style={ticketBottomStyle}>
            <p style={ticketHeaderTextStyle}>#{i+1}</p>
          </Accordion.Toggle>
          ))}
        </>
      ) : null}
    </Accordion>
  )
}

// Styles
const cardStyle = {
    display: "flex",
    flexDirection: "column",
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    border: "none",
};

const accordionStyle = {
  backgroundColor: '#1d2434',
  borderTopLeftRadius: '15px',
  borderTopRightRadius: '15px',
}

const cardBodyStyle = {
  backgroundColor: '#423f40',
  color: '#fff',
}
const cardInnerStyle = {
  backgroundColor: '#fff',
  color: '#fff',
  marginLeft: '6px',
  marginRight: '6px',
  marginTop: '12px',
  marginBottom: '12px',
  borderRadius: '6px',
  paddingLeft: '20px',
  paddingRight: '20px',
  paddingTop: '12px',
  paddingBottom: '12px',
}


const badgeStyle = {
    position: "absolute",
    left: 12,
    marginTop: "-5px",
};

const ticketHeaderStyle = {
  height: '45px',
  backgroundColor: '#1d2434',
  textAlign: 'center'
}

const ticketBottomStyle = {
  height: '25px',
  backgroundColor: '#1d2434',
  textAlign: 'center',
  width: '20%',
  display: 'inline-block',
  fontSize: '10px',
}

const ticketHeaderTextStyle = {
    fontSize: "14px",
    fontWeight: "600",
    color: "#fff",
    marginBottom: "auto",
};

const actionRowStyle = {
  display: 'flex',
  alignItems: 'stretch',
  gap: '12px',
  width: '100%',
}

const actionCancelWrapStyle = {
  flex: '0 0 34%',
  minWidth: 0,
}

const actionProcessWrapStyle = {
  flex: '1 1 66%',
  minWidth: 0,
}

const actionSingleWrapStyle = {
  flex: '1 1 100%',
  minWidth: 0,
}

const btnDeleteStyle = {
  minHeight: '48px',
  border: 'none',
  borderRadius: '6px',
  background: '#DC3545',
  color: '#fff',
  cursor: 'pointer',
  fontSize: '13px',
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '8px 12px',
  lineHeight: '1.25',
  whiteSpace: 'normal',
  textAlign: 'center',
  overflowWrap: 'break-word',
}
const btnProcessStyle = {
  minHeight: '48px',
  border: 'none',
  borderRadius: '6px',
  background: '#4CAF50',
  color: '#fff',
  cursor: 'pointer',
  fontSize: '13px',
  textTransform: 'uppercase',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '8px 12px',
  lineHeight: '1.25',
  whiteSpace: 'normal',
  overflowWrap: 'break-word',
}
const infoPaymentStyle = {
  color: '#4CAF50',
  fontSize: '2rem',
  textTransform: 'uppercase',
  textAlign: 'right',
  display: 'block',
  width: '100%'
}
